import { Component, Vue } from 'vue-property-decorator'
import { sprintf } from 'sprintf-js'

import CAOG1040Service from './CAOG1040Service'
import caog1040ViewModel from './CAOG1040ViewModel'
import CAOG1040ParamModel from './CAOG1040ParamModel'

import Store from '@/common/utils/Store'
import ValidationUtils from '@/common/utils/ValidationUtil'
import CommonUtil from '@/common/utils/CommonUtil'
import { createAccordion } from '@/common/utils/CreateAccordion'

import { XSSFilterOptions } from '@/common/XSSFilterOptions'
// vue components
import Pagination from '@/components/pagination/Pagination.vue'
import CategoryIcon from '@/components/icons/components/category-icon.vue'
import CommonConstants from '@/common/CommonConstants'
import TransportService from '@/common/TransportService'
import { fixedContent } from '@/assets/js/main.js'
@Component({
  name: 'CAOG1040',
  components: {
  Pagination,
  CategoryIcon
  }
  })

// 「」
export default class CAOG1040Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private PAGE_SIZE = 10
  private FORMAT_TITLE_RESULT_SEARCH = '%s%s%sに関する検索結果：%d件'
  private KEYWORD_MAX_LENGTH = 40

  private NO_RECORD = '該当する質問がありません。'

  private QUESTION_DIV_IDECO = '2'
  private QUESTION_DIV_COMPANY = '1'

  private caog1040Service: CAOG1040Service = new CAOG1040Service()
  private caog1040ParamModel: CAOG1040ParamModel = this.$route
    .params as CAOG1040ParamModel

  private caog1040ViewModel: caog1040ViewModel = {
    catInfoLst: new Array(6).fill({
      classId: null,
      classMei: ''
    }),
    searchKeyword: '',
    searchCategoryId: null,
    searchCategory: '',
    totalRecord: null,
    qaInfoLst: [
      {
        classId: null,
        title: '',
        memo: '',
        type: ''
      }
    ],
    filteredQaLst: [
      {
        classId: null,
        title: '',
        memo: '',
        type: ''
      }
    ],
    qaInSelectedPageLst: [
      {
        classId: null,
        title: '',
        memo: '',
        type: ''
      }
    ],
    currentPage: 1,
    titleResult: '',
    activeCategory: null,
    message: ''
  }

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    this.$root.$emit('renderTabIndexPage', '')
    this.$root.$emit('renderEvent', '')
  }

  /**
   * 初期処理
   */
  private async init() {
    const [caoa1040ResponseModel] = await Promise.all([
      this.caog1040Service.callAPICAAOA1040(),
      // システムアクティビティログを実行する（トランスポート）
      TransportService.callAPITransport(CommonConstants.URL_CAOG1040, null, null)
    ])
    const qaInfoLst = caoa1040ResponseModel.qaInfoLst

    const faqFilterLst = this.caog1040Service.filterQuestion(
      null,
      qaInfoLst ?? null,
      ''
    )

    if (CommonUtil.isNotEmpty(qaInfoLst)) {
      qaInfoLst.map((item) => {
        item.memo = item.memo?.replaceAll(
          CommonConstants.REGEX_LINE_BREAK,
          '<br/>'
        )

        return {
          ...item
        }
      })
      this.caog1040ViewModel.qaInfoLst = qaInfoLst
    } else {
      this.caog1040ViewModel.qaInfoLst = null
      this.caog1040ViewModel.message = this.NO_RECORD
    }

    this.caog1040ViewModel.catInfoLst = CommonUtil.isNotEmpty(
      caoa1040ResponseModel.catInfoLst
    )
      ? caoa1040ResponseModel.catInfoLst
      : null

    this.caog1040ViewModel.totalRecord = faqFilterLst?.length
    this.caog1040ViewModel.filteredQaLst = faqFilterLst
    this.caog1040ViewModel.qaInSelectedPageLst = faqFilterLst?.slice(
      0,
      this.PAGE_SIZE
    )

    this.caog1040ViewModel.titleResult = sprintf(
      this.FORMAT_TITLE_RESULT_SEARCH,
      'すべてのカテゴリー',
      '',
      '',
      faqFilterLst?.length || 0
    )

    createAccordion()

    this.clickSearchButton()
  }

  /**
   * よくあるご質問カテゴリリンク押下
   * @param id
   */
  private clickCategoryButton(id) {
    let categoryId = id

    this.caog1040ViewModel.activeCategory =
      this.caog1040ViewModel.activeCategory === categoryId ? null : categoryId

    this.caog1040ParamModel = null

    if (!this.caog1040ViewModel.activeCategory) categoryId = null

    if (categoryId === null) {
      this.caog1040ViewModel.searchCategoryId = null as any
      this.caog1040ViewModel.searchCategory = null
    } else if (categoryId) {
      const searchCategory = this.caog1040Service.getCategoryNameById(
        categoryId,
        this.caog1040ViewModel.catInfoLst
      )
      this.caog1040ViewModel.searchCategoryId = categoryId
      this.caog1040ViewModel.searchCategory = searchCategory
    }

    this.clickSearchButton()
  }

  /**
   * 検索ボタン押下
   */
  private clickSearchButton() {
    const isMaxLengthValid = ValidationUtils.isMaxLengthValid(
      this.KEYWORD_MAX_LENGTH,
      this.caog1040ViewModel.searchKeyword
    )
    if (isMaxLengthValid === false) {
      const errorMessage = []
      errorMessage.push({
        code: 'MSGCAOG1040WF001',
        message: CommonUtil.getMessage('MSGCAOG1040WF001', []),
        url: ''
      })
      return Store.setResponseErrors(errorMessage)
    } else {
      Store.setResponseErrors([])
      const filteredQaLst = this.caog1040Service.filterQuestion(
        this.caog1040ViewModel.searchCategoryId,
        this.caog1040ViewModel.qaInfoLst,
        this.caog1040ViewModel.searchKeyword
      )
      this.caog1040ViewModel.filteredQaLst = filteredQaLst

      const qaInSelectedPageLst = filteredQaLst?.slice(0, this.PAGE_SIZE)
      this.caog1040ViewModel.qaInSelectedPageLst = qaInSelectedPageLst
      this.caog1040ViewModel.currentPage = 1
      this.caog1040ViewModel.totalRecord = filteredQaLst?.length
    }
    this.caog1040ViewModel.message = this.NO_RECORD

    const searchKeyword = this.caog1040ViewModel.searchKeyword
    const searchCategory = this.caog1040ViewModel.searchCategory

    let strCatetory = ''
    let strNo = ''
    let strSearchKeyword = ''

    if (searchCategory === null || searchCategory === '') {
      strCatetory = 'すべてのカテゴリー'
    } else if (searchKeyword) {
      strCatetory = 'カテゴリー「' + searchCategory + '」'
    } else {
      strCatetory = '「' + searchCategory + '」'
    }

    if (searchKeyword) {
      strNo = searchCategory !== null ? 'のキーワード' : 'の'
      strSearchKeyword = '「' + searchKeyword + '」'
    }

    this.caog1040ViewModel.titleResult = sprintf(
      this.FORMAT_TITLE_RESULT_SEARCH,
      strCatetory,
      strNo,
      strSearchKeyword,
      this.caog1040ViewModel.filteredQaLst?.length || 0
    )

    this.$nextTick(() => {
      createAccordion()
      this.$root.$emit('renderTabIndexPage', '')
      this.$root.$emit('renderEvent', '')
    })
  }

  /**
   * 検索ボタン押下
   * @param selectedPage
   */
  private changePage(selectedPage) {
    const qaInSelectedPageLst = this.caog1040ViewModel.filteredQaLst.slice(
      (selectedPage - 1) * this.PAGE_SIZE,
      selectedPage * this.PAGE_SIZE
    )
    this.caog1040ViewModel.qaInSelectedPageLst = qaInSelectedPageLst
    this.caog1040ViewModel.currentPage = selectedPage
    createAccordion()
    this.$root.$emit('renderTabIndexPage', '')
    this.$root.$emit('renderEvent', '')
  }
}
